import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { postData } from '../Services/api';
import { toast } from 'react-toastify';
import JoditEditor from 'jodit-react';

const CmsAdd = () => {
    const editor = useRef(null);
    const [values, setValues] = useState({
        title: "",
        content: "",
    })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }

    const validateCMS = () => {
        const { title, content, } = values;

        if (!title.trim()) {
            toast.dismiss();
            toast.error("Title is required.");
            return false;
        }
        if (!content.trim()) {
            toast.dismiss();
            toast.error("Description is required.");
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateCMS()) return;
        setLoading(true)
        try {
            const res = await postData('/cms/create', values);
            if (res.status) {
                toast.success(res.message)
                navigate('/cms/cms-list');
                setValues({
                    title: "",
                    content: "",
                })
            }
        } catch (error) {
            console.log("error cms page adding", error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/cms/cms-list">
                                                CMS</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add CMS
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Add CMS</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add CMS</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Title"
                                                        name='title'
                                                        value={values.title}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Description</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={values.content}
                                                        onChange={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                content: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                               <Link to="/cms/cms-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CmsAdd